import React from 'react';
import { changeDateFilter } from '../services/navigation';
import PropTypes from 'prop-types';

function DateFilterDropdownItem({search, title, options}) {

	const change = e => {
		changeDateFilter(search, title.toLowerCase(), e.target.value);
	};
	
	return (
		<div>
			<label className="visuallyhidden" htmlFor={title}>{title}</label>
			<select id={title} name={title} value={search[title.toLowerCase()]} onChange={change} className="filter__element">
				<option value="">{title}</option>
				{options.map((key, index) => (<option key={key} value={key == 'All' ? '' : (title === 'Month' || title === 'Mis') ? index : key}>{key}</option>))}
			</select>
		</div>			
	);
}

DateFilterDropdownItem.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.array,
	title: PropTypes.string
};

export default DateFilterDropdownItem;